import axiosInstance from "../../axios/axios";
import * as adminActions from "./adminActions";
import { FeatureFlagStatusesDto } from "./dtos/FeatureFlagStatusesDto";
import QueryResponse from "./shared models/QueryResponse";
import { requestHeader } from "./sharedUtils";

export const passUserDetail = (user: any) => {
  // some aync logic
  return {
    type: adminActions.USER_DETAIL,
    user: user,
  };
};

export const getFeatureFlagStatuses = async (): Promise<
  [QueryResponse<FeatureFlagStatusesDto> | null, any]
> => {
  try {
    const response = await axiosInstance.get<
      QueryResponse<FeatureFlagStatusesDto>
    >(`/featureFlagStatuses`, requestHeader);
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};
